export default "__VITE_ASSET__DYqDFnGY__"